export const IPSEAMTemplateHeaders = [
    { label: "No", key: "No" },
    { label: "Cluster Center", key: "clusterCenter" },
    { label: "Site", key: "Site" },
    { label: "Asset Category", key: "assetCategory" },
    { label: "Manufacturer", key: "manufacturer" },
    { label: "Model", key: "model" },
    { label: "PM Schedule Description", key: "pmScheduleDescription" },
    { label: "Qty", key: "qty" },
    { label: "Unit Of Measure", key: "unitOfMeasure" },
    { label: "Unit Price", key: "unitPrice" },
    { label: "Total", key: "total" },
    { label: "Currency", key: "currency" },
    { label: "Supplier OFA ID", key: "supplierOfaId" }
];

export const IPSEAMHeaderListForProcessing = IPSEAMTemplateHeaders.map(header => {
    return header.key;
});

export const IPSEAMBuyerProhibitedColumns = [
    'unitPrice',
    'total'
];

export const IPSEAMSupplierProhibitedColumns = IPSEAMTemplateHeaders.map(header => {
    if (!IPSEAMBuyerProhibitedColumns.includes(header.key)) {
        return header.key
    }
    return '';
});

export const IPSEAMHeaderListForCSV = IPSEAMTemplateHeaders.map(header => {
    return header.label;
}).join() + '\n';